/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetDirectoryRoleMappingForm,
  SetDirectoryRoleMappingForm$Outbound,
  SetDirectoryRoleMappingForm$outboundSchema,
} from "../components/setdirectoryrolemappingform.js";

export type SetDirectoryRoleMappingSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetDirectoryRoleMappingRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setDirectoryRoleMappingForm: SetDirectoryRoleMappingForm;
};

/** @internal */
export type SetDirectoryRoleMappingSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetDirectoryRoleMappingSecurity$outboundSchema: z.ZodMiniType<
  SetDirectoryRoleMappingSecurity$Outbound,
  SetDirectoryRoleMappingSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setDirectoryRoleMappingSecurityToJSON(
  setDirectoryRoleMappingSecurity: SetDirectoryRoleMappingSecurity,
): string {
  return JSON.stringify(
    SetDirectoryRoleMappingSecurity$outboundSchema.parse(
      setDirectoryRoleMappingSecurity,
    ),
  );
}

/** @internal */
export type SetDirectoryRoleMappingRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  SetDirectoryRoleMappingForm: SetDirectoryRoleMappingForm$Outbound;
};

/** @internal */
export const SetDirectoryRoleMappingRequest$outboundSchema: z.ZodMiniType<
  SetDirectoryRoleMappingRequest$Outbound,
  SetDirectoryRoleMappingRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    setDirectoryRoleMappingForm: SetDirectoryRoleMappingForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      setDirectoryRoleMappingForm: "SetDirectoryRoleMappingForm",
    });
  }),
);

export function setDirectoryRoleMappingRequestToJSON(
  setDirectoryRoleMappingRequest: SetDirectoryRoleMappingRequest,
): string {
  return JSON.stringify(
    SetDirectoryRoleMappingRequest$outboundSchema.parse(
      setDirectoryRoleMappingRequest,
    ),
  );
}
